import ko = require("knockout");
import MergeFieldChooser = require("./mergeFieldChooser");

export class MergeFieldChooserRegistration {
    register() {
        console.log("registration in progress");

        ko.components.register("merge-field-chooser", {
            viewModel:MergeFieldChooser.MergeFieldChooserViewModel,
            template: require("./mergeFieldChooser.html")
        });
    }
}
